import React from "react";
import { connect } from "react-redux";
import AccountLogin from "./component";
import withCommonLayout from "../layout/component-common";
import { withRouter } from "react-router";

const mapStateToProps = ({
    user: { isLoggedIn }
}) => ({
    isLoggedIn
});

export default withRouter(connect(mapStateToProps, () => ({}))(withCommonLayout(AccountLogin)));
